import { render, staticRenderFns } from "./HistoryViewing.vue?vue&type=template&id=336eb55b&scoped=true"
import script from "./HistoryViewing.vue?vue&type=script&lang=js"
export * from "./HistoryViewing.vue?vue&type=script&lang=js"
import style0 from "./HistoryViewing.vue?vue&type=style&index=0&id=336eb55b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336eb55b",
  null
  
)

export default component.exports